"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ThemeProvider from "./ThemeProvider";
import themeLight from "@lib/theme/light";
import AxiosProvider from "./AxiosProvider";
import SessionProvider from "./SessionProvider";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 2,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
  },
});

export default function RootProviders({ children, session }) {
  return (
    <ThemeProvider theme={themeLight}>
      <SessionProvider session={session}>
        <AxiosProvider session={session}>
          <QueryClientProvider client={queryClient}>
            {children}
          </QueryClientProvider>
        </AxiosProvider>
      </SessionProvider>
    </ThemeProvider>
  );
}
